import type { CSSProperties, ReactNode } from 'react'

type ControlledOpenProps = { open: boolean; onOpenChange(open: boolean): void; defaultOpen?: never }

type UncontrolledOpenProps = {
  open?: never
  defaultOpen?: boolean
  onOpenChange?: ((open: boolean) => void) | undefined
}

export type ControlledOpenState = ControlledOpenProps | UncontrolledOpenProps

export type OverlayPositionerProps<Offset extends number = number> = {
  anchor?: HTMLElement | null
  children: ReactNode
  side?: 'top' | 'bottom' | 'left' | 'right'
  align?: 'start' | 'center' | 'end'
  sideOffset?: Offset
  mobileSheet?: boolean
}

export const mobileSheetPosition: CSSProperties = {
  position: 'fixed',
  top: 64,
  left: 0,
  transform: 'none',
  width: '100%',
}
